import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { 
  CheckCircle, 
  FileText,
  Clock,
  ArrowRight,
  Mail
} from 'lucide-react';

const QuoteConfirmation = () => {
  const { quoteNumber } = useParams();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12">
      <div className="max-w-md w-full mx-auto px-4">
        {/* Success Card */}
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          {/* Success Icon */}
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 text-blue-600 rounded-full mb-6">
            <CheckCircle className="w-10 h-10" />
          </div>
          
          {/* Success Message */}
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Richiesta Preventivo Inviata!
          </h1>
          <p className="text-gray-600 mb-2">
            La tua richiesta è stata ricevuta con successo.
          </p>
          
          {/* Quote Number */}
          {quoteNumber && (
            <div className="mb-6 p-4 bg-blue-50 rounded-lg">
              <p className="text-sm text-blue-800 font-medium">
                Numero Preventivo
              </p>
              <p className="text-lg font-bold text-blue-900">
                {quoteNumber}
              </p>
            </div>
          )}

          {/* Info Cards */}
          <div className="space-y-3 mb-8 text-left">
            <div className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg">
              <Mail className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-gray-900">
                  Email di Conferma Inviata
                </p>
                <p className="text-xs text-gray-600">
                  Controlla la tua casella di posta per i dettagli
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg">
              <Clock className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-gray-900">
                  Risposta in 24-48 ore
                </p>
                <p className="text-xs text-gray-600">
                  Il nostro team ti contatterà con un preventivo personalizzato
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg">
              <FileText className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-gray-900">
                  Visualizza nella Dashboard
                </p>
                <p className="text-xs text-gray-600">
                  Puoi seguire lo stato del preventivo nella tua area personale
                </p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            {/* View Quotes Button */}
            <Link
              to="/dashboard?tab=quotes"
              className="w-full inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
            >
              <FileText className="w-5 h-5 mr-2" />
              Visualizza i Tuoi Preventivi
            </Link>

            {/* Create Another Quote/Product Button */}
            <Link
              to="/creator"
              className="w-full inline-flex items-center justify-center px-6 py-3 bg-white text-blue-600 font-semibold rounded-lg border border-blue-600 hover:bg-blue-50 transition-colors"
            >
              Crea un Altro Liquore
            </Link>

            {/* Home Button */}
            <Link
              to="/"
              className="w-full inline-flex items-center justify-center px-6 py-2 text-gray-600 font-medium hover:text-blue-600 transition-colors"
            >
              <ArrowRight className="w-4 h-4 mr-1" />
              Torna alla Homepage
            </Link>
          </div>

          {/* Help Text */}
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              Hai domande? Contattaci a{' '}
              <a href="mailto:info@iltuoamaro.it" className="text-blue-600 hover:underline">
                info@iltuoamaro.it
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteConfirmation;
